import { Card, Input, notification, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { getRequest } from "services/EndPointApiService";
import TableViewManualan from "./TableViewManualan";
import { UpdateStatusPesanan } from "services/datalist/datalist-api";

export default function Manualan() {
  let user = localStorage.getItem("auth-id");
  const userObj = JSON.parse(user);
  const [data, setData] = useState([]);

  const [inputSearch, setInputSearch] = useState("");
  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    getRequest("DataList/GetDataTFSManual").then((res) => {
      if (res && res.length > 0) {
        let initial = res.map((item, index) => ({ key: index + 1, ...item }));
        setData(initial);
        setDataSource(initial);
      }
    });
  }, []);

  const handleKirim = async (record, action) => {
    if (
      window.confirm(
        `Kirim pesanan untuk ${record.Nama}? Pastikan user sudah membayar.`
      )
    ) {
      var data = {
        sesionId: record.SesionID,
        sequence: record.No,
        user: userObj.firstName,
        action: action,
        notes: "",
      };

      const { affect } = await UpdateStatusPesanan(data);

      if (affect && affect > 0) {
        notification.success({
          message: "Update Status Pesanan",
          description: "Status pesanan berhasil di update",
        });
      } else {
        notification.error({
          message: "Update Status Pesanan",
          description: "Status pesanan gagal diupdate. Coba lagi nanti",
        });
      }
    }
  };

  return (
    <>
      <h2>Transfer Susulan (TFS)</h2>
      <Card
        title={
          <Space>
            <PlusOutlined />
            <span>Tambah pengiriman manual dari data history</span>
          </Space>
        }
      >
        <Input.Search
          placeholder="Cari nama atau nomer hp"
          style={{ marginBottom: "10px", maxWidth: "350px" }}
          value={inputSearch}
          onChange={({ target }) => setInputSearch(target.value)}
          onKeyDown={(e) => {
            if (e.code === "Enter") {
              let newData = data.filter(
                (d) =>
                  d.Nama.toString()
                    .toLowerCase()
                    .includes(inputSearch?.toLowerCase()) ||
                  d.Target.toString()
                    .toLowerCase()
                    .includes(inputSearch?.toLowerCase())
              );
              setDataSource(newData);
            }
          }}
          onSearch={() => {
            let newData = data.filter(
              (d) =>
                d.Nama.toString()
                  .toLowerCase()
                  .includes(inputSearch?.toLowerCase()) ||
                d.Target.toString()
                  .toLowerCase()
                  .includes(inputSearch?.toLowerCase())
            );
            setDataSource(newData);
          }}
        />
        <br />
        <TableViewManualan data={dataSource} onKirim={handleKirim} />
      </Card>
    </>
  );
}
